import e from"./Breadcrumb.vue_vue&type=script&lang.js";import{render as r}from"./Breadcrumb.vue_vue&type=template&id=6f46de9a&lang.js";e.render=r,e.__file="src/components/Breadcrumb.vue";export default e;
//# sourceMappingURL=Breadcrumb.vue.js.map
